export const CALL_BAR_HEIGHT = 44
export const JOIN_CHANNEL_CALL_BAR_HEIGHT = 44
export const JOIN_MEETING_BAR_HEIGHT = 44
export const PIN_VIEWER_HEIGHT = 44
export const SCHEDULED_CALL_BAR_HEIGHT = 56
